import React from 'react';
import PropTypes from 'prop-types';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import { LocalizationProvider, DesktopTimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { es } from 'date-fns/locale';

const optionIconSx = { '& .MuiSvgIcon-root': { fontSize: 28 } };

const ShippingWorkOptions = ({
  t,
  language,
  hours,
  withCrane,
  withoutCrane,
  adr,
  others,
  onHoursBlur,
  onHoursChange,
  onWithCraneChange,
  onWithoutCraneChange,
  onAdrChange,
  onOthersChange,
}) => (
  <div className="shipping-work-options">
    <div className="shipping-work-hours">
      <label className="text-primary">{t('Text_SHIPPING_DOING').toUpperCase()} :</label>
        <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={language === 'es' ? es : undefined}>
          <DesktopTimePicker
            id="hours"
            name="hours"
            value={hours !== null ? new Date(hours) : null}
            fullWidth
            format="HH:mm"
            ampm={false}
            timeSteps={{ minutes: 30 }}
            onBlur={onHoursBlur}
            onChange={onHoursChange}
            slotProps={{
              textField: {
                placeholder: '00:00',
                inputProps: { 'aria-label': t('Text_SHIPPING_HOURS') },
                sx: { maxLength: 110, width: '100%', fontSize: '18px' },
                InputProps: { style: { fontSize: '18px' } },
              },
            }}
          />
        </LocalizationProvider>
    </div>
    <div className="shipping-work-checks">
      <FormControlLabel
        label={t('Text_SHIPPING_CRANE')}
        control={<Checkbox id="withcrane" name="withcrane" checked={withCrane} onChange={onWithCraneChange} sx={optionIconSx} />}
      />
      <FormControlLabel
        label={t('Text_SHIPPING_WITHOUTCRANE')}
        control={<Checkbox id="withoutcrane" name="withoutcrane" checked={withoutCrane} onChange={onWithoutCraneChange} sx={optionIconSx} />}
      />
      <FormControlLabel
        label={t('Text_SHIPPING_ADR')}
        control={<Checkbox id="adr" name="adr" checked={adr} onChange={onAdrChange} sx={optionIconSx} />}
      />
      <FormControlLabel
        label={t('Text_SHIPPING_OTHERS')}
        control={<Checkbox id="others" name="others" checked={others} onChange={onOthersChange} sx={optionIconSx} />}
      />
    </div>
  </div>
);

ShippingWorkOptions.propTypes = {
  t: PropTypes.func.isRequired,
  language: PropTypes.string.isRequired,
  hours: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.instanceOf(Date)]),
  withCrane: PropTypes.bool.isRequired,
  withoutCrane: PropTypes.bool.isRequired,
  adr: PropTypes.bool.isRequired,
  others: PropTypes.bool.isRequired,
  onHoursBlur: PropTypes.func.isRequired,
  onHoursChange: PropTypes.func.isRequired,
  onWithCraneChange: PropTypes.func.isRequired,
  onWithoutCraneChange: PropTypes.func.isRequired,
  onAdrChange: PropTypes.func.isRequired,
  onOthersChange: PropTypes.func.isRequired,
};

export default ShippingWorkOptions;
